import React, { useContext, useEffect, useMemo, useState } from "react";
import Axios from "../../_services/caller.service";
//STYLES
import styles from "./ManageCertificat.module.scss";
//ANIMATION
import { motion } from "framer-motion";
import { animatePage } from "../../animation/animationPage";
//COMPONENT
import HeaderArrayCertificat from "../calibration/certificatDownload/HeaderArrayCertifcat";
import OneCertificat from "./OneCertificat";
//HOOK
import LoaderLogin from "../UiComponents/loader/LoaderLogin";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import NavContext from "../../context/NavContext";
import ReminderLateCalibration from "./RemindersLateCalibration";
import CalibrationConfig from "./CalibrationConfig";
import UpcomingCalibrations from "./UpComingCalibrations";
import UpcomingCalibrationsChart from "./UpcomingCalibrationsChart";
import TestReminders from "./TestReminders";

import { FiMail, FiBell, FiSettings, FiCalendar, FiActivity } from "react-icons/fi";

const ManageCertificat = () => {
  const { t } = useTranslation();

  // L'onglet Test n'est monté côté serveur que si ENABLE_TEST_REMINDERS=true.
  // On l'affiche donc uniquement quand le front est explicitement configuré.
  const TEST_TAB_ENABLED =
    process.env.REACT_APP_ENABLE_TEST_REMINDERS === "true";

  const TABS = [
    { key: "certificats", label: t("calibration.certificates"), icon: <FiMail /> },
    { key: "reminders",   label: t("calibration.reminders"),    icon: <FiBell /> },
    { key: "config",      label: t("common.configuration"), icon: <FiSettings /> },
    { key: "upcoming",    label: t("calibration.upcoming"),     icon: <FiCalendar /> },
    ...(TEST_TAB_ENABLED
      ? [{ key: "test", label: t("calibration_test.tab"), icon: <FiActivity /> }]
      : []),
  ];

  //TAB
  const [activeTab, setActiveTab] = useState("certificats");

  //DATA
  const [allCabines, setAllCabines] = useState([]);
  const [cabineWithCalib, setCabineWithCalib] = useState([]);
  const [users, setUsers] = useState([]);
  const [userToSendEmail, setUserToSendEmail] = useState({});

  //SEARCH CABINE STATE
  const [searchCabCertif, setSearchCabCertif] = useState("");
  const [radioNameCertif, setRadioNameCertif] = useState(false);

  //LOADING
  const [loadingAll, setLoadingAll] = useState(true);
  const [loadingUser, setLoadingUser] = useState(true);
  const [loadingCabines, setLoadingCabines] = useState(true);
  const [loadingDataReminders, setLoadingDataReminders] = useState(true);
  const [loadingCabineUser, setLoadingCabineUser] = useState(true);

  //CONTEXT
  const {
    ownerId,
    realOwnerId,
    userAuth,
    superAdmin,
    ownerProfile,
    adminProfile,
  } = useContext(NavContext);
  //GESTION affichage du nombre de certificat
  const [visibleCount, setVisibleCount] = useState(3);
  const handleLoadMore = () => {
    setVisibleCount((prevCount) => prevCount + 10);
  };

  const handleShowAll = () => {
    setVisibleCount(filteredCertificat.length);
  };
  const handleShowLess = () => {
    // Ajouté
    setVisibleCount(53);
  };

  //VERFY IF CABINE HAVE CALIBRATION DATA
  // (kept for reference; no longer used: information now comes from the
  //  batched /calibrationDaysAll endpoint via `hasCalibrationGeneral`.)

  //GET ALL CABINES + BATCH DAYS / CALIBRATION FLAG
  useEffect(() => {
    let cancelled = false;

    // 1) Cabines de base (affichage rapide)
    const cabinesPromise = Axios.get(`/allCabines/`)
      .then((response) => {
        if (cancelled) return [];
        const dataCab = response.data.data || [];
        setLoadingCabines(false);
        return dataCab;
      })
      .catch((error) => {
        console.log(error);
        if (!cancelled) setLoadingCabines(false);
        return [];
      });

    // 2) Données de calibration en un seul appel (remplace N+N requêtes)
    const calibPromise = Axios.get(`/calibrationDaysAll`)
      .then((response) => response.data?.data || [])
      .catch((error) => {
        console.log(error);
        return [];
      });

    Promise.all([cabinesPromise, calibPromise])
      .then(([dataCab, calibArray]) => {
        if (cancelled) return;

        // Map cabId -> données de calibration
        const calibById = new Map();
        for (const c of calibArray) {
          calibById.set(c.id, c);
        }

        // Fusion : injecte numberDay* directement dans chaque cabine
        const merged = dataCab.map((cab) => {
          const c = calibById.get(cab.id);
          return c ? { ...cab, ...c } : cab;
        });

        // Cabines à afficher dans l'onglet Certificats : celles qui ont
        // des données dans Calibration_General (ancien filtre).
        const withCalib = calibArray
          .filter((c) => c.hasCalibrationGeneral)
          .map((c) => c.id);

        setAllCabines(merged);
        setCabineWithCalib(withCalib);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  // GET ALL USERS
  useEffect(() => {
    Axios.get("/getAllUserForSuperAdmin")
      .then((response) => {
        setLoadingUser(false);
        setUsers(response.data.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  //STATE CABID PAR CABID
  const handleSetUserToSendEmail = (email, cabId) => {
    setUserToSendEmail((prevState) => ({
      ...prevState,
      [cabId]: email,
    }));
  };

  // Fonction pour réinitialiser le state pour un cabId spécifique
  const handleResetUserToSendEmail = (cabId) => {
    setUserToSendEmail((prevState) => {
      const newState = { ...prevState };
      delete newState[cabId]; // Supprimer l'entrée pour ce cabId
      return newState;
    });
  };

  //FONCTION ENVOIE PDF PAR MAIL
  const sendCertifByMail = (cabId) => {
    const emailToSend = userToSendEmail[cabId];

    // ICI ON ENVOIE UN EMAIL AU USER ET NON PAS GENERER UN PDF MAIS LA ROUTE PEUX GERER LES DEUX
    Axios.post(`/generatePdf/${cabId}`, {
      sendByMail: true,
      emailToSend: emailToSend,
    })

      .then(function async(response) {
        toast.success(t("email.sent_success_certif"));

        handleResetUserToSendEmail(cabId);
      })
      .catch(function (error) {
        toast.error(t("email.error_sending_certif"));
        console.log(error);
      });
  };

  //FONCTION POUR FILTRER LES CABINES (mémorisé pour éviter les recalculs/re-render)
  const filteredCertificat = useMemo(() => {
    const cabIdsWithCalib = new Set(cabineWithCalib);
    const search = (searchCabCertif || "").toLowerCase();
    return allCabines
      .filter((cab) => cabIdsWithCalib.has(cab.id))
      .filter((cab) => cab.cabname.toLowerCase().includes(search))
      .sort((a, b) =>
        radioNameCertif
          ? b.cabname.localeCompare(a.cabname)
          : a.cabname.localeCompare(b.cabname)
      );
  }, [allCabines, cabineWithCalib, searchCabCertif, radioNameCertif]);

  // LOADING : on n'attend QUE les cabines + utilisateurs.
  // Les données de calibration arrivent par le batch et sont injectées
  // au fur et à mesure ; pas besoin de bloquer le rendu plus longtemps.
  useEffect(() => {
    if (!loadingUser && !loadingCabines) {
      setLoadingAll(false);
    }
  }, [loadingUser, loadingCabines]);


  if (loadingAll) {
    return (
      <div className={styles.loaderPage}>
        <LoaderLogin />
      </div>
    );
  }

  return (
    <motion.div
      className={styles.page}
      variants={animatePage}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
          <div className={styles.header}>
            <h2>{t("calibration.manage_certificates_title")}</h2>
          </div>

      <div className={styles.tabBar}>
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`${styles.tabBtn} ${activeTab === tab.key ? styles.tabActive : ""}`}
          >
            {tab.icon} {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.tabContent}>
        {/* ── Onglet Certificats ── */}
        {activeTab === "certificats" && (
          <div className={styles.section}>
            <div className={styles.moduleCard}>
              <HeaderArrayCertificat
                setSearchCabCertif={setSearchCabCertif}
                searchCabCertif={searchCabCertif}
              />

              <div className={styles.tableWrapper}>
                <table className={styles.table}>
                  <thead>
                    <tr>
                      <th className={styles.th}>{t("calibration.cabin")}</th>
                      <th className={styles.thCenter}>{t("calibration.co")}</th>
                      <th className={styles.thCenter}>{t("calibration.headphones")}</th>
                      <th className={styles.thCenter}>Insert</th>
                      <th className={styles.thCenter}>{t("calibration.cl")}</th>
                      <th className={styles.th}>{t("calibration.recipient")}</th>
                      <th className={styles.thActions}>{t("calibration.actions")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allCabines.length > 0 &&
                      cabineWithCalib.length >= 1 &&
                      filteredCertificat.slice(0, visibleCount).map((cab) => (
                        <OneCertificat
                          key={cab.id}
                          cab={cab}
                          cabine={allCabines}
                          cabname={cab.cabname}
                          sendCertifByMail={() => sendCertifByMail(cab.id)}
                          users={users}
                          email={userToSendEmail[cab.id]}
                          setLoadingCabineUser={setLoadingCabineUser}
                          setUserToSendEmail={(email) =>
                            handleSetUserToSendEmail(email, cab.id)
                          }
                        />
                      ))}
                  </tbody>
                </table>
              </div>

              <div className={styles.paginationActions}>
                {visibleCount < filteredCertificat.length && (
                  <button
                    onClick={handleLoadMore}
                    className={styles.btnPrimary}
                  >
                    {t("calibration.show_more")}
                  </button>
                )}
                {visibleCount < filteredCertificat.length && (
                  <button
                    onClick={handleShowAll}
                    className={styles.btnPrimary}
                  >
                    {t("calibration.show_all")}
                  </button>
                )}
                {visibleCount >= filteredCertificat.length && (
                  <button
                    onClick={handleShowLess}
                    className={styles.btnPrimary}
                  >
                    {t("calibration.show_less")}
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ── Onglet Relances ── */}
        {activeTab === "reminders" && (
          <div className={styles.section}>
            <ReminderLateCalibration setLoadingDataReminders={setLoadingDataReminders} />
          </div>
        )}

        {/* ── Onglet Configuration ── */}
        {activeTab === "config" && (
          <div className={styles.section}>
            <CalibrationConfig />
          </div>
        )}

        {/* ── Onglet À venir ── */}
        {activeTab === "upcoming" && (
          <div className={styles.section}>
            <UpcomingCalibrationsChart />
            <UpcomingCalibrations />
          </div>
        )}

        {/* ── Onglet Test ── */}
        {TEST_TAB_ENABLED && activeTab === "test" && (
          <div className={styles.section}>
            <TestReminders />
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default ManageCertificat;
